export default __webpack_public_path__ + "static/media/sb-text-logo-white.ffe35425.svg";